import { defineStore } from 'pinia';
import axiosInstance from '@/stores/modules/axios';

const useApiStore = defineStore('api', {
    actions: {
        requestApi(params) {
            let { url } = params;
            const { method = 'get', data = {}, headers = {} } = params;

            const axiosConfig = {
                method,
                url,
                data,
                headers: { ...headers },
            };

            return axiosInstance
                .request(axiosConfig)
                .then((res) => res)
                .catch((err) => {
                    console.log(err);
                });
        },
    },
});

export default useApiStore;
